import { actions, assign, createMachine } from 'xstate';
const fetchMachine = createMachine({
    predictableActionArguments: true,
    id: 'fetchMachine',
    schema: {
        context: {}
    },
    initial: 'loading',
    states: {
        loading: {
            invoke: {
                src: 'fetch',
                onDone: {
                    target: 'success',
                    actions: assign({
                        data: (context, { data }) => data
                    })
                },
                onError: {
                    target: 'error',
                    actions: assign({
                        error: (context, { data }) => data
                    })
                }
            }
        },
        success: {
            type: 'final',
            data: ({ cacheKey, data }) => [cacheKey, data]
        },
        error: {
            type: 'final',
            entry: actions.escalate(({ cacheKey, error }) => [cacheKey, error])
        }
    }
}, {
    services: {
        fetch: ({ cacheKey, queryClient, queryFn }) => queryClient.fetchQuery({
            queryKey: cacheKey,
            queryFn
        })
    }
});
export default fetchMachine;
